// POST JSON to a Rails endpoint, including the CSRF token from the layout's
// <meta name="csrf-token"> so Rails' forgery protection is satisfied.
export function postJSON(url, body) {
  const token = document.querySelector('meta[name="csrf-token"]')?.content
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      ...(token ? { 'X-CSRF-Token': token } : {}),
    },
    body: JSON.stringify(body),
  })
}
